import { Link } from "@reach/router";
import * as React from "react";
const SimpleLink = ({
  children,
  to,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("a", {
    href: to,
    ...props
  }, children);
};
const LinkWithBasePath = ({
  children,
  to,
  ...props
}) => {
  const basePath = globalThis.xing.basePath === "/" ? "" : globalThis.xing.basePath;
  return /* @__PURE__ */ React.createElement(Link, {
    to: `${basePath}${to}`,
    ...props
  }, children);
};
const isListed = (item, list) => list !== void 0 && Boolean(list.find((listItem) => {
  let url = listItem.split("?")[0];
  url = url.length > 1 ? url.replace(/\/$/, "") : url;
  const pattern = `^${url.replace("/", "\\/")}(\\/.*)?(\\?.*)?$`;
  return new RegExp(pattern, "i").test(item);
}));
const getHooks = (useFrameHooks) => {
  const useLinkComponent = (url) => {
    const { useFrameContext } = useFrameHooks();
    const { internalPaths } = useFrameContext();
    if (typeof url === "string") {
      return isListed(url, internalPaths) ? LinkWithBasePath : SimpleLink;
    } else {
      return url ? LinkWithBasePath : SimpleLink;
    }
  };
  return { useLinkComponent };
};
const reachLinkModule = { getHooks };
export {
  reachLinkModule
};
